/**
 * @file 反馈页入口
 * @author FengGuang(fengguang01@baidu.com)
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import React from 'react';
import ReactDOM from 'react-dom';

import Feedback from './Feedback';

import './style.less';



ReactDOM.render(<Feedback />, document.getElementById('root'));


